import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Common,
  Permissionkeys,
  Spinner
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const Permissions = () => {
  const history = useHistory()
  const [PermissionList, setPermissionList] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)

  const [isForceUpdate, setForceUpdate] = useState(false)

  const columns = [
    {
      name: 'Name',
      selector: (row) => row.name
    },
    {
      name: 'Description',
      selector: (row) => row.description
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          {row.name !== 'Master' && (
            <div className="action-btn">
              <Link
                to={'/permission/edit/' + row.id}
                className="text-dark"
                title="Edit"
              >
                <i
                  className="fa fa-pencil-square-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
              <Link
                onClick={(e) => DeletePermission(e, row.id)}
                to=""
                className="text-dark"
                title="Delete"
              >
                <i
                  className="fa fa-trash-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
            </div>
          )}
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Permissions
    if (!Common.validatePermission(Permissionkeys.rolepermission)) {
      history.push('/')
    }
    GetPermissionList()
  }, [CustomFilters])

  const GetPermissionList = () => {
    setLoading(true)
    HttpService.getApi(API.GetPermission).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[0]
        setPermissionList(data)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  // const subHeaderComponentMemo = React.useMemo(() => {
  //   return (
  //     <input
  //       type="text"
  //       title="Search For Name."
  //       className="form-control col-md-3"
  //       placeholder="Search"
  //       onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
  //     />
  //   )
  // })

  const DeletePermission = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          _id: id
        }
        setLoading(true)
        HttpService.postApi(API.DeletePermission, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetPermissionList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Permissions} </h3>
        <div className="btn-group">
          <Link
            to="/permission/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Permission{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={PermissionList}
                  // progressPending={loading}
                  // pagination
                  paginationServer
                  persistTableHead={true}
                  // paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  // subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Permissions
